import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import useApiUrls from "../../useApiUrls";

const Sendcampaign = () => {
  
  const { merchant, pos } = useParams();
  const [activeTab, setActiveTab] = useState("single");
  const [merchantname, setMerchantname] = useState(merchant || "");
  const [posid, setPosid] = useState(pos);
  const [campaignid, setCampaignid] = useState("");
  const [responseData, setResponseData] = useState(null); 
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); 

  const [merchantList, setMerchantList] = useState([]);
  const [posList, setPosList] = useState([]);
  const [campaignList, setCampaignList] = useState([]);
  
  // Group campaign states
  const [selectedSubGroupsCampaign, setSelectedSubGroupsCampaign] = useState([]);
  const [subGroupCampaignId, setSubGroupCampaignId] = useState("");
  const [subGroupCampaignLoading, setSubGroupCampaignLoading] = useState(false);
  const [subGroupCampaignResponseData, setSubGroupCampaignResponseData] = useState(null);
  const [subGroupCampaignErrorMessage, setSubGroupCampaignErrorMessage] = useState("");
  const [groupList, setGroupList] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();


  const fetchMerchants = async () => {
    
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    try {
      const posGetDistinctMerchantId = getUrlByOperation("posGetDistinctMerchantId");
      
      if (!posGetDistinctMerchantId) {
        console.error("URL for posGetDistinctMerchantId operation not found.");
        return;
      }

      const response = await axios.get(posGetDistinctMerchantId, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setMerchantList(response.data.data.map((item) => item.merchantid));
      } else {
        setMerchantList([]);
        console.warn("Merchant list is empty or in unexpected format.");
      }
    } catch (error) {
      console.error("Error fetching merchant list:", error);
      if (error.response?.data.message === "relogin token expire") {
        navigate("/login"); 
      }
    }
  };

  
  const fetchPosByMerchant = async (merchantId) => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const posGetDistinct = getUrlByOperation("posGetDistinct");
    

    if (!posGetDistinct) {
      console.error("URL for posGetDistinct operation not found.");
      return;
    }

    const url = new URL(`specificmerchantid/${merchantId}`, posGetDistinct).toString();
    

    try {
      const response = await axios.get(url, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
        },
      });

      if (response.data && Array.isArray(response.data.data)) {
        setPosList(response.data.data.map((item) => ({
          id: item.id,
          value: item.value,
        })));
      } else {
        setPosList([]);
        console.warn("POS list is empty or in unexpected format.");
      }
    } catch (error) {
      console.error("Error fetching POS list:", error.message);
      console.debug("Error details:", error.response || error);
    }
  };

  // Fetch Campaign IDs from the search API
  const fetchCampaignIds = async () => {

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      filesize: 0,
      id: 0,
      applycreateddate: false,
      fromcreateddate: 0,
      endcreateddate: 0,
      active: "",
      orgfilename: "",
      systemfilename: "",
      downloadpath: "",
      name: "",
      ispageload: false,
      pagesize: 1000,
      currentpageno: 0,
      withoutpagination: false,
      pagedirection: "first",
    };

    try {
      const CampaignSearch = getUrlByOperation("CampaignSearch");
   

      const response = await axios.post(CampaignSearch,
        requestBody,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setCampaignList(response.data.data); // Set the Campaign list with data from the API
      } else {
        setCampaignList([]);
      }
    } catch (error) {
      console.error("Error fetching Campaign IDs:", error);
    }
  };

  // Fetch groups and subgroups
  const fetchGroups = async () => {
    const token = getCookie("token");
    const userid = getCookie("userid");

    try {
      const response = await axios.get(
        "https://api.dqr-display-tms.bonrix.in/api/SubGroupOperation/SubUser/GroupAndSubGroup",
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            accept: "text/plain",
          },
        }
      );

      if (response.data && Array.isArray(response.data.data)) {
        setGroupList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  // Handle group selection (select all subgroups in a group)
  const handleGroupSelect = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata) return;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const allSelected = subgroupIds.every((id) =>
      selectedSubGroupsCampaign.includes(id)
    );

    if (allSelected) {
      // Deselect all subgroups in this group
      setSelectedSubGroupsCampaign(
        selectedSubGroupsCampaign.filter((id) => !subgroupIds.includes(id))
      );
    } else {
      // Select all subgroups in this group
      const newSelection = [...selectedSubGroupsCampaign];
      subgroupIds.forEach((id) => {
        if (!newSelection.includes(id)) {
          newSelection.push(id);
        }
      });
      setSelectedSubGroupsCampaign(newSelection);
    }
  };

  // Handle individual subgroup selection
  const handleSubGroupSelect = (subgroupId) => {
    if (selectedSubGroupsCampaign.includes(subgroupId)) {
      setSelectedSubGroupsCampaign(
        selectedSubGroupsCampaign.filter((id) => id !== subgroupId)
      );
    } else {
      setSelectedSubGroupsCampaign([...selectedSubGroupsCampaign, subgroupId]);
    }
  };

  // Check if all subgroups in a group are selected
  const isGroupFullySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    return subgroupIds.every((id) => selectedSubGroupsCampaign.includes(id));
  };

  // Check if some (but not all) subgroups in a group are selected
  const isGroupPartiallySelected = (groupId) => {
    const group = groupList.find((g) => g.id === groupId);
    if (!group || !group.subgroupdata || group.subgroupdata.length === 0)
      return false;

    const subgroupIds = group.subgroupdata.map((sg) => sg.id);
    const selectedCount = subgroupIds.filter((id) =>
      selectedSubGroupsCampaign.includes(id)
    ).length;

    return selectedCount > 0 && selectedCount < subgroupIds.length;
  };

  // Get selected subgroup names for display
  const getSelectedSubGroupNames = () => {
    const names = [];
    groupList.forEach((group) => {
      if (group.subgroupdata) {
        group.subgroupdata.forEach((sg) => {
          if (selectedSubGroupsCampaign.includes(sg.id)) {
            names.push(sg.name);
          }
        });
      }
    });
    return names;
  };


  // Function to handle the API call
  const handleSendCampaign = async () => {
    if (!campaignid) {
      setErrorMessage("Please select an Campaign.");
      return;
    }

    setLoading(true);
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const requestBody = {
      merchantname,
      posid: parseInt(posid),
      campaignid: parseInt(campaignid),
    };

    try {
      const SendToDeviceCampaign = getUrlByOperation("SendToDeviceCampaign");

      if (!SendToDeviceCampaign) {
        console.error("URL for SendToDeviceCampaign operation not found.");
        setLoading(false);
        return;
      }

      const response = await axios.post(SendToDeviceCampaign, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          "Content-Type": "application/json",
        },
      });

      if (response.data && response.data.sendresult) {
        setResponseData(response.data.sendresult);
        setErrorMessage(""); 
      } else {
        setResponseData(null);
        setErrorMessage(response.data.errormsg || "No matching records found");
      }
    } catch (error) {
      console.error("Error sending Campaign:", error);
      setErrorMessage("Failed to send Campaign.");
    } finally {
      setLoading(false);
    }
  };

  // Function to handle Send Campaign to SubGroup API call
  const handleSendCampaignToSubGroup = async () => {
    if (selectedSubGroupsCampaign.length === 0) {
      setSubGroupCampaignErrorMessage("Please select at least one subgroup");
      return;
    }

    if (!subGroupCampaignId) {
      setSubGroupCampaignErrorMessage("Please select a campaign");
      return;
    }

    setSubGroupCampaignLoading(true);
    const token = getCookie("token");
    const userid = getCookie("userid");

    const apiUrl =
      "https://api.dqr-display-tms.bonrix.in/api/SendToDevice/SubUser/SG/Campaign";
    const requestBody = {
      subgroupids: selectedSubGroupsCampaign,
      campaignid: parseInt(subGroupCampaignId),
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "X-Authorization": token,
          UserId: userid,
          accept: "text/plain",
          "Content-Type": "application/json-patch+json",
        },
      });

      if (response.data) {
        setSubGroupCampaignResponseData(response.data);
        setSubGroupCampaignErrorMessage("");
        setSelectedSubGroupsCampaign([]);
        setSubGroupCampaignId("");
      }

      setSubGroupCampaignLoading(false);
    } catch (error) {
      console.error("Error sending campaign to subgroup:", error);
      setSubGroupCampaignErrorMessage(
        error.response?.data?.errormsg || "Error sending campaign to subgroup"
      );
      setSubGroupCampaignLoading(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchCampaignIds();
    fetchGroups();
  }, [getUrlByOperation]);

  return (
    <>
      <Menu />
      <div className="content-wrapper" style={{ padding: "20px" }}>
        {/* Tab Navigation */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
            backgroundColor: "#fff",
            borderRadius: "8px",
            width: "400px",
            margin: "0 auto 20px",
            borderBottom: "1px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          <button
            style={{
              flex: 1,
              padding: "12px",
              backgroundColor:
                activeTab === "single" ? "#007bff" : "transparent",
              color: activeTab === "single" ? "#fff" : "#333",
              border: "none",
              cursor: "pointer",
              borderRadius: "8px 0 0 0",
              fontWeight: activeTab === "single" ? "bold" : "normal",
              transition: "all 0.3s ease",
            }}
            onClick={() => setActiveTab("single")}
          >
            Single
          </button>
          <button
            style={{
              flex: 1,
              padding: "12px",
              backgroundColor:
                activeTab === "group" ? "#007bff" : "transparent",
              color: activeTab === "group" ? "#fff" : "#333",
              border: "none",
              cursor: "pointer",
              borderRadius: "0 8px 0 0",
              fontWeight: activeTab === "group" ? "bold" : "normal",
              transition: "all 0.3s ease",
            }}
            onClick={() => setActiveTab("group")}
          >
            Group
          </button>
        </div>

        {/* Single Tab Content */}
        {activeTab === "single" && (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              width: "400px",
              margin: "auto",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>Send Campaign</h4>
            <div className="form-group">
              <label>Merchant Name</label>
              {merchant ? (
                <select className="form-control" value={merchantname} disabled>
                  <option value={merchant}>{merchant}</option>
                </select>
              ) : (
                <select
                  className="form-control"
                  value={merchantname}
                  onChange={(e) => {
                    const selectedMerchant = e.target.value;
                    setMerchantname(selectedMerchant);
                    setPosid("");
                    if (selectedMerchant) {
                      fetchPosByMerchant(selectedMerchant);
                    } else {
                      setPosList([]);
                    }
                  }}
                  onFocus={fetchMerchants}
                >
                  <option value="Select">Select</option>
                  <option value="All">All</option>
                  {merchantList.map((merchant, index) => (
                    <option key={index} value={merchant}>
                      {merchant}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="form-group">
              <label>POS ID</label>
              {pos ? (
                <select className="form-control" value={posid} disabled>
                  <option value={pos}>{pos}</option>
                </select>
              ) : (
                <select
                  className="form-control"
                  value={posid}
                  onChange={(e) => setPosid(e.target.value)}
                  disabled={!merchantname}
                >
                  <option value="0">All</option>
                  {posList.map((pos, index) => (
                    <option key={index} value={pos.id}>
                      {pos.value}
                    </option>
                  ))}
                </select>
              )}
            </div>
            <div className="form-group">
              <label>Campaign ID</label>
              <select
                className="form-control"
                value={campaignid}
                onChange={(e) => {
                  setCampaignid(e.target.value);
                  setErrorMessage("");
                }}
              >
                <option value="">Select Campaign</option>
                {campaignList.map((campaign, index) => (
                  <option key={index} value={campaign.id}>
                    {campaign.campaignname}
                  </option>
                ))}
              </select>
              {errorMessage && !campaignid && (
                <div style={{ color: "red", marginTop: "0.5rem" }}>
                  {errorMessage}
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <button
                className="btn btn-primary"
                onClick={handleSendCampaign}
                disabled={loading || !campaignid}
              >
                {loading ? "Sending..." : "Send Campaign"}
              </button>
            </div>
          </div>
        )}

        {/* Group Tab Content */}
        {activeTab === "group" && (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2rem",
              borderRadius: "8px",
              width: "600px",
              margin: "auto",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          >
            <h4 style={{ marginBottom: "20px" }}>
              Send Campaign to SubGroup
            </h4>

            <div className="form-group">
              <label>Campaign</label>
              <select
                className="form-control"
                value={subGroupCampaignId}
                onChange={(e) => setSubGroupCampaignId(e.target.value)}
              >
                <option value="">Select Campaign</option>
                {campaignList.map((campaign, index) => (
                  <option key={index} value={campaign.id}>
                    {campaign.campaignname}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Select Subgroups</label>
              <div ref={dropdownRef} style={{ position: "relative" }}>
                {/* Dropdown Toggle */}
                <div
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  style={{
                    border: "1px solid #ced4da",
                    borderRadius: "4px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    minHeight: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ color: selectedSubGroupsCampaign.length === 0 ? "#999" : "#333" }}>
                    {selectedSubGroupsCampaign.length === 0
                      ? "Select subgroups..."
                      : `${selectedSubGroupsCampaign.length} subgroup(s) selected`}
                  </span>
                  <i
                    className={`fas fa-chevron-${
                      isDropdownOpen ? "up" : "down"
                    }`}
                    style={{ color: "#666" }}
                  ></i>
                </div>

                {/* Dropdown Menu */}
                {isDropdownOpen && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ced4da",
                      borderRadius: "4px",
                      marginTop: "4px",
                      maxHeight: "400px",
                      overflowY: "auto",
                      zIndex: 1000,
                      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    {groupList.length > 0 ? (
                      groupList.map((group) => (
                        <div key={group.id}>
                          {group.subgroupdata &&
                            group.subgroupdata.length > 0 && (
                              <div>
                                {/* Group Header */}
                                <div
                                  onClick={() => handleGroupSelect(group.id)}
                                  style={{
                                    padding: "10px 15px",
                                    backgroundColor: "#f8f9fa",
                                    borderBottom: "1px solid #e9ecef",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    display: "flex",
                                    alignItems: "center",
                                    transition: "background-color 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#e9ecef")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#f8f9fa")
                                  }
                                >
                                  <input
                                    type="checkbox"
                                    checked={isGroupFullySelected(group.id)}
                                    ref={(input) => {
                                      if (input) {
                                        input.indeterminate =
                                          isGroupPartiallySelected(group.id);
                                      }
                                    }}
                                    onChange={() => {}}
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      marginRight: "10px",
                                      cursor: "pointer",
                                      accentColor: "#007bff",
                                    }}
                                  />
                                  <i
                                    className="fas fa-folder"
                                    style={{ marginRight: "8px", color: "#ffc107" }}
                                  ></i>
                                  {group.name}
                                  <span
                                    style={{
                                      marginLeft: "auto",
                                      fontSize: "12px",
                                      color: "#666",
                                      backgroundColor: "#fff",
                                      padding: "2px 8px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {group.subgroupdata.length}
                                  </span>
                                </div>

                                {/* Subgroups */}
                                {group.subgroupdata.map((subgroup) => (
                                  <div
                                    key={subgroup.id}
                                    onClick={() =>
                                      handleSubGroupSelect(subgroup.id)
                                    }
                                    style={{
                                      padding: "8px 15px 8px 45px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      borderBottom: "1px solid #f0f0f0",
                                      backgroundColor:
                                        selectedSubGroupsCampaign.includes(
                                          subgroup.id
                                        )
                                          ? "#e3f2fd"
                                          : "#fff",
                                      transition: "background-color 0.2s",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (
                                        !selectedSubGroupsCampaign.includes(
                                          subgroup.id
                                        )
                                      ) {
                                        e.currentTarget.style.backgroundColor =
                                          "#f8f9fa";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (
                                        !selectedSubGroupsCampaign.includes(
                                          subgroup.id
                                        )
                                      ) {
                                        e.currentTarget.style.backgroundColor =
                                          "#fff";
                                      }
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={selectedSubGroupsCampaign.includes(
                                        subgroup.id
                                      )}
                                      onChange={() => {}}
                                      style={{
                                        width: "16px",
                                        height: "16px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        accentColor: "#007bff",
                                      }}
                                    />
                                    <i
                                      className="fas fa-layer-group"
                                      style={{
                                        marginRight: "8px",
                                        color: "#6c757d",
                                        fontSize: "12px",
                                      }}
                                    ></i>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        color: selectedSubGroupsCampaign.includes(
                                          subgroup.id
                                        )
                                          ? "#007bff"
                                          : "#495057",
                                      }}
                                    >
                                      {subgroup.name}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                      ))
                    ) : (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          color: "#999",
                        }}
                      >
                        No subgroups available
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Selected Items Display */}
              {selectedSubGroupsCampaign.length > 0 && (
                <div
                  style={{
                    marginTop: "10px",
                    padding: "10px",
                    backgroundColor: "#e3f2fd",
                    borderRadius: "4px",
                    border: "1px solid #90caf9",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <i
                      className="fas fa-check-circle"
                      style={{ color: "#1976d2", marginRight: "8px" }}
                    ></i>
                    <strong style={{ color: "#1976d2", fontSize: "13px" }}>
                      {selectedSubGroupsCampaign.length} subgroup(s) selected
                    </strong>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      maxHeight: "100px",
                      overflowY: "auto",
                    }}
                  >
                    {getSelectedSubGroupNames().map((name, index) => (
                      <span
                        key={index}
                        style={{
                          backgroundColor: "#fff",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          color: "#495057",
                          border: "1px solid #90caf9",
                        }}
                      >
                        {name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1.5rem",
              }}
            >
              <button
                className="btn btn-primary btn-lg"
                onClick={handleSendCampaignToSubGroup}
                disabled={
                  subGroupCampaignLoading ||
                  selectedSubGroupsCampaign.length === 0 ||
                  !subGroupCampaignId
                }
                style={{ flex: 1 }}
              >
                {subGroupCampaignLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm mr-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Sending...
                  </>
                ) : (
                  <>
                    <i className="fas fa-paper-plane mr-2"></i>
                    Send Campaign to SubGroup
                  </>
                )}
              </button>
            </div>

            {subGroupCampaignErrorMessage && (
              <div
                className="alert alert-danger mt-3"
                style={{ fontSize: "14px" }}
              >
                <i className="fas fa-exclamation-circle mr-2"></i>
                {subGroupCampaignErrorMessage}
              </div>
            )}
            {subGroupCampaignResponseData && (
              <div
                className="alert alert-success mt-3"
                style={{ fontSize: "14px" }}
              >
                <i className="fas fa-check-circle mr-2"></i>
                Campaign sent to subgroup(s) successfully!
              </div>
            )}
          </div>
        )}

        <section className="content">
          <div className="container-fluid">
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-12">
                <div className="card shadow-sm">
                  <div className="card-header bg-light">
                    <h3 className="card-title">
                      <i className="fas fa-chart-line mr-2"></i>
                      Campaign Response Results
                    </h3>
                  </div>
                  <div className="card-body table-responsive p-0">
                    <table className="table table-hover table-striped mb-0">
                      <thead className="thead-dark">
                        <tr>
                          <th>Type</th>
                          <th>Merchant Name</th>
                          <th>POS Name</th>
                          <th>Response Status</th>
                          <th>Message/Error</th>
                          <th>Status Badge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* Display Single Campaign Results */}
                        {responseData &&
                          responseData.length > 0 &&
                          responseData.map((result, index) => (
                            <tr key={`single-${index}`}>
                              <td>
                                <span className="badge badge-info">Single</span>
                              </td>
                              <td>{result.merchantname || "-"}</td>
                              <td>{result.posname || "-"}</td>
                              <td>{result.responsestatus || "-"}</td>
                              <td>{result.errormsg || "-"}</td>
                              <td>
                                {result.responsestatus === "SUCCESS" ? (
                                  <span className="badge badge-success">
                                    ✓ Success
                                  </span>
                                ) : (
                                  <span className="badge badge-danger">
                                    ✗ Failed
                                  </span>
                                )}
                              </td>
                            </tr>
                          ))}

                        {/* Display SubGroup Campaign Response Data */}
                        {subGroupCampaignResponseData &&
                          subGroupCampaignResponseData.sendresult &&
                          subGroupCampaignResponseData.sendresult.length >
                            0 &&
                          subGroupCampaignResponseData.sendresult.map(
                            (result, index) => (
                              <tr key={`subgroup-${index}`}>
                                <td>
                                  <span className="badge badge-secondary">
                                    SubGroup
                                  </span>
                                </td>
                                <td>{result.merchantname || "-"}</td>
                                <td>{result.posname || "-"}</td>
                                <td>{result.responsestatus || "-"}</td>
                                <td>{result.errormsg || "-"}</td>
                                <td>
                                  {result.responsestatus === "SUCCESS" ? (
                                    <span className="badge badge-success">
                                      ✓ Success
                                    </span>
                                  ) : (
                                    <span className="badge badge-danger">
                                      ✗ Failed
                                    </span>
                                  )}
                                </td>
                              </tr>
                            )
                          )}

                        {/* Show empty state when no data */}
                        {!responseData &&
                          !subGroupCampaignResponseData && (
                            <tr>
                              <td
                                colSpan="6"
                                style={{
                                  textAlign: "center",
                                  padding: "40px 20px",
                                }}
                              >
                                <i
                                  className="fas fa-inbox"
                                  style={{
                                    fontSize: "3rem",
                                    color: "#ccc",
                                    marginBottom: "10px",
                                  }}
                                ></i>
                                <p style={{ color: "#999", marginBottom: 0 }}>
                                  {errorMessage ||
                                    subGroupCampaignErrorMessage ||
                                    "No data available yet. Send a campaign to see results here."}
                                </p>
                              </td>
                            </tr>
                          )}

                        {/* Show message when all are empty but we tried to send */}
                        {responseData &&
                          responseData.length === 0 &&
                          !subGroupCampaignResponseData && (
                            <tr>
                              <td
                                colSpan="6"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  color: "#999",
                                }}
                              >
                                No results to display
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Sendcampaign;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
